import { ParentGuardianInfoSubmitter } from '../../lib/parent-guardian-info/parent-guardian-info-submit.service'

export class DocsParentGuardianInfoSubmitter implements ParentGuardianInfoSubmitter {
  public matchingDupe
  public matchingEmail
  public submitting = false

  public submit(): void {
    alert('Navigate to create-password')
  }

  public emailMatchSignIn(): void {
    // nooop
  }

  public validateAndSubmit(): void {
    // noop
  }
}
